export const APPOINTMENT_ITEM_ADDED = "APPOINTMENT_ITEM_ADDED";
export const APPOINTMENT_RECEIVED = "APPOINTMENT_RECEIVED";
export const PATIENT_LIST_RECEIVED = "PATIENT_LIST_RECEIVED";
